export default {"src":"/_next/static/media/fairplay_footer.1694fc1e.svg","height":41,"width":197,"blurWidth":0,"blurHeight":0};